import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import "bootstrap";
import "./assets/styles/theme.css";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import { createHead } from "@vueuse/head";

const app = createApp(App);
const head = createHead();

app.use(store);
app.use(router);
app.use(i18n);
app.use(head);

app.mount("#app");
